import {Icon, IconProps} from '@chakra-ui/react';

export const ImageIcon: React.FC<IconProps> = (props) => (
  <Icon
    viewBox='0 0 15 15'
    {...props}
  >
    <path
      d='M1.66667 15C1.20833 15 0.815972 14.8368 0.489583 14.5104C0.163194 14.184 0 13.7917 0 13.3333V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H8.33333V1.66667H1.66667V13.3333H13.3333V6.66667H15V13.3333C15 13.7917 14.8368 14.184 14.5104 14.5104C14.184 14.8368 13.7917 15 13.3333 15H1.66667ZM2.5 11.6667H12.5L9.375 7.5L6.875 10.8333L5 8.33333L2.5 11.6667ZM11.6667 5V3.33333H10V1.66667H11.6667V0H13.3333V1.66667H15V3.33333H13.3333V5H11.6667Z'
      fill='currentColor'
    />
  </Icon>
);
